<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="errmsg"
        label="错误信息"
        align="center"
      />
    </el-table>
    <div v-if="type === 1" style="margin-top:10px">
      <el-button type="primary" @click="empty">清空重新选择</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tableData: [],
      type: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(arr, type) {
      console.log('arr', arr)
      this.tableData = arr
      this.type = type
    },
    empty() {
      this.$emit('emptyaccount')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
